module.exports = "/_next/static/images/77b496fed530394a41ebca256a6a6c8f-doggo-xs.jpg.webp";